import { Component, inject, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TourService } from 'ngx-ui-tour-md-menu';
import { IstepOptionCustom } from './tour-step-option';
import { TourStepsService } from 'src/app/services/tour-steps.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { GaEventModule } from 'src/app/directives/ga-event/ga-event.module';

@Component({
  selector: 'app-tour-step',
  standalone: true,
  imports: [NgIcon, NgClass, GaEventModule],
  providers: [provideIcons({heroXMark})],
  templateUrl: './tour-step.component.html',
  styleUrl: './tour-step.component.scss'
})
export class TourStepComponent {
  protected tourService = inject(TourService);
  private tourStepsService = inject(TourStepsService);
  private apiUsuario = inject(ApiUsuarioService);

  @Input() step!: IstepOptionCustom;
  
  protected closeTour = () => {
    this.tourService.end();
    this.tourStepsService.currentAnchor.set('');
  }
  
  protected confirmAction = (tourRef: 'TOUR-MENU' | 'TOUR-RESULTADOS') => {    
    const preferencias = this.apiUsuario.getPreferenciasStorage();
    let userPreferencias: { menuStepCompleted: boolean, tourCompleted: boolean, dicaStepCompleted:boolean } = {...preferencias};

    if (tourRef === "TOUR-MENU") {
      userPreferencias = { ...userPreferencias, menuStepCompleted: true };
    } else {
      userPreferencias = {...userPreferencias, tourCompleted: true};
    }

    localStorage.setItem("usuarioPreferencias", JSON.stringify(userPreferencias));
   
    this.tourService.end();
    this.tourStepsService.resetTour();
    
    this.apiUsuario.salvarConfigs(userPreferencias).subscribe({
      next: () => {},
      error: (error: HttpErrorResponse) => {
        console.log("Erro ao salvar preferencias de usuario ", error);
      }
    });
  }
}
